import { CODESMITH_EXTENSION_EMBED_VALUE } from "@/lib/codesmithExtensionEmbed";

/**
 * Where the dashboard is running: a browser tab or the Chrome extension's side
 * panel iframe (`?embed=extension`).
 */
export type CodesmithSurface = "web" | "extension";

type EmbedParam = string | string[] | null | undefined;

/** For event handlers and effects. `embed` is the page's `embed` query value. */
export function codesmithSurface(embed: EmbedParam): CodesmithSurface {
  const extension = Array.isArray(embed)
    ? embed.includes(CODESMITH_EXTENSION_EMBED_VALUE)
    : embed === CODESMITH_EXTENSION_EMBED_VALUE;
  return extension ? "extension" : "web";
}

/** For render. */
export function useCodesmithSurface(embed: EmbedParam): CodesmithSurface {
  return codesmithSurface(embed);
}
